// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import Request from './request';

async function fetch(data) {
    return Request('get', "api/shop-sales", data);
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shop-sales/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function fetchOne(id, data) {// 获取单个
    return Request('get', "api/shop-sales/" + id, data);
}

async function exportOne(id, data) {// 导出单个的报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shop-sales/export-detail/" + id, data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function exportsJX(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/ShopSales/shopOrderCountJiangXiExport",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

async function exportsSL(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/ShopSales/shopOrderCountSanLianExport",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch, exports,
    fetchOne, exportOne,
    exportsJX,
    exportsSL,
};